import React, { PureComponent } from "react";
import { json } from "react-router";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
const LB3D = ({
  index,
  totalLength,
  totalWidth,
  totalThickness,
  LP,
  BLK,
  profile,
  setIsOpen
}) => {
  const LBContainer = React.useRef(null);
  const colorMap={
    "LP":"#46A3EC",
    "VP":"green",
    "HP":"red",
    "MP":"yellow",
    "PR":"#B0E57C",
    "ST SLAB":"purple",
    "FS":"#2596be"

  };
  const [color, setColor] = React.useState(colorMap[profile]?colorMap[profile]:"black");
  const [mode, setMode] = React.useState("free");
  const totalArea = (totalLength * totalThickness) / Math.pow(10, 6);
  const [UnCoveredArea, setUnCoveredArea] = React.useState(0);
  const createLP = (length, width, thickness, resizeFactor, x, y, z, scene) => {
    var LPGeometry = new THREE.BoxGeometry(
      resizeFactor * length,
      resizeFactor * thickness,
      resizeFactor * width
    );


    var LPmaterial = new THREE.MeshPhongMaterial({
      color: color,
      side: THREE.DoubleSide
    });

    var LPEdges = new THREE.EdgesGeometry(LPGeometry);
    var LPedgesMaterial = new THREE.LineBasicMaterial({
      color: 0x000000,
      depthTest: true
    });
    var LPLines = new THREE.LineSegments(LPEdges, LPedgesMaterial);
    var LP = new THREE.Mesh(LPGeometry, LPmaterial);
    LP.position.x = (resizeFactor * length) / 2 + 0.02 + x;
    LP.position.y = (resizeFactor * thickness) / 2+0.1 + y;
    LP.position.z = (resizeFactor * width) / 2 + 0.02 + z;
    scene.add(LP);
    LP.add(LPLines);
    console.log("LP created");
  };
  React.useEffect(() => {



      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(
        60,
        window.innerWidth / window.innerHeight,
        0.1,
        500
      );

      var renderer = new THREE.WebGLRenderer({antialias:true});
      renderer.setSize(1080, 550);
      renderer.setClearColor(0xffffff);
      // use ref as a mount point of the Three.js scene instead of the document.body
       while(LBContainer.current?.children.length>0){
          LBContainer.current.removeChild(LBContainer.current.firstChild);
       }
        LBContainer?.current?.appendChild(renderer.domElement);

      var axesHelper = new THREE.AxesHelper(5);
      //scene.add(axesHelper);
      const orbit = new OrbitControls(camera, renderer.domElement);
      const resizeFactor = 0.001;
      camera.position.z = 7;
      camera.position.y = 3;
      camera.position.x = 2;
      orbit.update();
      var cubeGeometry = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        0.1,
        resizeFactor * totalThickness + 0.2
      );
      var material = new THREE.MeshPhongMaterial({
        color: "gray",
        side: THREE.DoubleSide
      });
      var base = new THREE.Mesh(cubeGeometry, material);
      base.position.x = (resizeFactor * totalLength) / 2;
      base.position.y = 0.05;
      base.position.z = (resizeFactor * totalThickness) / 2;

      base.updateMatrixWorld();
      base.name = "base";
      scene.add(base);

      // Add edges for the base
      var rightSide = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        resizeFactor * totalWidth+0.1,
        0.1
      );
      var right = new THREE.Mesh(rightSide, material);
      right.position.x = (resizeFactor * totalLength) / 2;
      right.position.y = (resizeFactor * totalWidth) / 2+0.05;
      right.position.z = -0.1;
      scene.add(right);

      var leftSide = new THREE.BoxGeometry(
        resizeFactor * totalLength + 0.2,
        resizeFactor * totalWidth+0.1,
        0.1
      );
      var left = new THREE.Mesh(leftSide, material);
      left.position.x = (resizeFactor * totalLength) / 2;
      left.position.y = (resizeFactor * totalWidth) / 2+0.05;
      left.position.z = resizeFactor * totalThickness + 0.1;
      scene.add(left);

      var topGeometry = new THREE.BoxGeometry(
        0.1,
        (resizeFactor * totalWidth)+0.1,
        resizeFactor * totalThickness + 0.3
      );
      var top = new THREE.Mesh(topGeometry, material);
      top.position.x = -0.05;
      top.position.y = ((resizeFactor * totalWidth) / 2)+0.05;
      top.position.z = (resizeFactor * totalThickness) / 2;
      scene.add(top);

      var botGeometry = new THREE.BoxGeometry(
        0.1,
        (resizeFactor * totalWidth)+0.1,
        resizeFactor * totalThickness + 0.3
      );
      var bot = new THREE.Mesh(botGeometry, material);
      bot.position.x = 0.1 + resizeFactor * totalLength;
      bot.position.y = ((resizeFactor * totalWidth) / 2)+0.05;
      bot.position.z = (resizeFactor * totalThickness) / 2;
      scene.add(bot);

      /*let wastedSpaceGeo = new THREE.BoxGeometry(
        resizeFactor * totalLength,
        0.01,
        resizeFactor * totalThickness
      );
      wastedSpaceGeo.translate(
        (resizeFactor * totalLength) / 2,
        0.005,
        (resizeFactor * totalThickness) / 2
      );




      let wastedSpaceMat = new THREE.MeshPhongMaterial({
        color: "yellow",
        side:THREE.DoubleSide


      });
      let wastedSpace = new THREE.Mesh(wastedSpaceGeo, wastedSpaceMat);
      scene.add(wastedSpace);


      const AddHashes=()=>{
        const hashMaterial = new THREE.LineBasicMaterial({
            color: "black",

            });
        for (let i = 0; ((totalLength-i>=totalLength/16)&&i <= 15/16* totalLength); i+=totalLength/32) {
            let hash = new THREE.Line(
                new THREE.BufferGeometry().setFromPoints([
                    new THREE.Vector3(
                        ((i+totalLength/16)) * resizeFactor,
                        0.01,
                        0.02
                    ),
                    new THREE.Vector3(
                        (i) * resizeFactor,
                        0.01,
                        totalThickness * resizeFactor
                    )
                ]),
                hashMaterial
            );
            scene.add(hash);
          let invertHash = new THREE.Line(

            new THREE.BufferGeometry().setFromPoints([
                new THREE.Vector3(
                    ((totalLength-i)) * resizeFactor,
                    0.05,
                    totalThickness * resizeFactor
                ),
                new THREE.Vector3(
                    (totalLength-i-totalLength/16) * resizeFactor,
                    0.05,
                    0.02
                )
            ]),
            hashMaterial
        );
        scene.add(invertHash);

        }
      }
        AddHashes();
*/
      const createBLK = (
        length,
        thickness,
        width,
        resizeFactor,
        x,
        y,
        z,
        scene
      ) => {
        var BLKGeometry = new THREE.BoxGeometry(
          resizeFactor * length,
          resizeFactor * thickness,
          resizeFactor * width
        );
        var BLKmaterial = new THREE.MeshPhongMaterial({
          color: "orange",
          side: THREE.DoubleSide
        });
        var BLKEdges = new THREE.EdgesGeometry(BLKGeometry);
        var BLKedgesMaterial = new THREE.LineBasicMaterial({
          color: 0x000000,
          depthTest: true
        });
        var BLKLines = new THREE.LineSegments(BLKEdges, BLKedgesMaterial);
        var BLK = new THREE.Mesh(BLKGeometry, BLKmaterial);
        BLK.position.x = (resizeFactor * length) / 2 + 0.02 + x;
        BLK.position.y = (resizeFactor * thickness) / 2 + 0.02 + y;
        BLK.position.z = (resizeFactor * width) / 2 + 0.02 + z;
        scene.add(BLK);
        BLK.add(BLKLines);
      };
      const DrawLPAndBLK = () => {
        let [
          templength,
          tempwidth,
          tempThikcness,
          i,
          j,
          k,
          tempLP,
          tempBLK,
          MaxInRow,
          MinInRow
        ] = [
          totalLength,
          totalWidth,
          totalThickness,
          0,
          0,
          0,
          LP&&JSON.parse(JSON.stringify(LP)),
          BLK&&JSON.parse(JSON.stringify(BLK)),
          LP?.length>0&&LP[0]?.length,
          LP?.length>0&& LP[0]?.length
        ];
        let row = 0;
        let lengths = {};
        let thicks = [];
        let thickIndex;
        let temp = 0;

        while (templength > 0 && tempLP?.length > 0) {
          row = 0;
          tempThikcness = totalThickness;
          thickIndex = 0;
          if (LP?.length != tempLP?.length) {
            if (
              tempLP[0]?.itemType === "BLK" &&
              (profile === "LP" ||
                profile == "VP" ||
                profile == "HP" ||
                profile == "MP") &&
              tempLP[0]?.length <= tempLP[0]?.width
            ) {
              templength -= tempLP[0]?.width;
            } else {
              templength -= MaxInRow;

              const maxBarrierGeo = new THREE.BoxGeometry(
                0.01,
                totalWidth * resizeFactor,
                totalThickness * resizeFactor
            );
            maxBarrierGeo.translate(
               ( (totalLength - templength) * resizeFactor  )+0.01,
                totalWidth * resizeFactor / 2,
                totalThickness * resizeFactor / 2
            );

            const maxBarrierMaterial = new THREE.MeshPhongMaterial({
                color: "red",
                side: THREE.BackSide,
                transparent: true,
                opacity: 0.5
            });

            const maxBarrier = new THREE.Mesh(
                maxBarrierGeo,
                maxBarrierMaterial
            );

            // Adding the maxBarrier to the scene
            scene.add(maxBarrier);

            }
          }

          while (tempThikcness >= tempLP[0]?.thickness && tempLP.length > 0) {
            tempwidth = totalWidth;

            temp +=
              (tempLP[0]?.length * tempLP[0]?.thickness) / Math.pow(10, 6);
            // console.log(temp);
            while (tempwidth - tempLP[0]?.width >= 0 && tempLP.length > 0) {
              if (tempLP.length > 0) {
                while (
                  templength != totalLength &&
                  thicks[thickIndex] != tempLP[0]?.thickness &&
                  thicks.length - 1 >= thickIndex &&
                  tempThikcness > 0
                ) {
                  tempThikcness -= thicks[thickIndex];
                  thickIndex++;
                }
                if (tempThikcness - tempLP[0].thickness > tempLP[0].thickness) {
                  MaxInRow = Math.max(MaxInRow, tempLP[0].length);
                  MinInRow = Math.min(MinInRow, tempLP[0].length);
                }
                if (tempLP[0]['partLot_BuildingType_c'] === "BLK") {
                  if (
                    profile === "ST SLAB" ||
                    profile == "PR" ||
                    tempLP[0].length > tempLP[0].width
                  ) {
                    createBLK(
                      tempLP[0].length,
                      tempLP[0].width,
                      tempLP[0].thickness,
                      resizeFactor,
                      (totalLength - templength) * resizeFactor,
                      (totalWidth - tempwidth) * resizeFactor,
                      (totalThickness - tempThikcness) * resizeFactor,
                      scene
                    );
                  } else {
                    createBLK(
                      tempLP[0].width,
                      tempLP[0].length,
                      tempLP[0].thickness,
                      resizeFactor,
                      (totalLength - templength) * resizeFactor,
                      (totalWidth - tempwidth) * resizeFactor,
                      (totalThickness - tempThikcness) * resizeFactor,
                      scene
                    );
                  }
                } else {
                  createLP(
                    tempLP[0].length,
                    tempLP[0].thickness,
                    tempLP[0].width,
                    resizeFactor,
                    (totalLength - templength) * resizeFactor,
                    (totalWidth - tempwidth) * resizeFactor,
                    (totalThickness - tempThikcness) * resizeFactor,
                    scene,

                  );
                }

                if (
                  tempLP[0].itemType === "BLK" &&
                  (profile === "LP" ||
                    profile == "VP" ||
                    profile == "HP" ||
                    profile == "MP" ||
                    tempLP[0].length > tempLP[0].width)
                ) {
                  tempwidth -= MaxInRow;
                } else {
                  tempwidth -= tempLP[0].width;
                }

                if (tempwidth <= 0) {
                  if (lengths[row] === undefined) {
                    lengths[row] = totalLength - tempLP[0].length;
                  } else {
                    lengths[row] -= tempLP[0].length;
                  }

                  row++;
                }
              }
            }
            if (tempLP[0]?.width >= tempwidth) {
              while (
                templength != totalLength &&
                thicks[thickIndex] != tempLP[0]?.thickness &&
                thicks.length - 1 >= thickIndex &&
                tempThikcness > 0
              ) {
                tempThikcness -= thicks[thickIndex];
                thickIndex++;
              }
              tempThikcness -= tempLP[0]?.thickness;
              thickIndex++;
              if (templength == totalLength) {
                thicks.push(tempLP[0]?.thickness);
              }
            }

            tempLP.shift();
          }
        }
        setUnCoveredArea(totalArea - temp);

        /* let templength2=templength+(MaxInRow-MinInRow);
           let tempThikcness2=tempThikcness;
           let tempwidth2=tempwidth;

            while(templength2>0&&tempBLK.length>0){
                tempThikcness2=tempThikcness;
                while(tempThikcness2>0&&tempBLK.length>0){
                    tempwidth2=totalWidth;
                    while(tempwidth2>0&&tempBLK.length>0){
                        if(tempBLK.length>0){
                            createBLK(tempBLK[0].width,tempBLK[0].length,tempBLK[0].thickness,resizeFactor,(totalLength-templength2)*resizeFactor,(totalWidth-tempwidth2)*resizeFactor,(totalThickness-tempThikcness2)*resizeFactor,scene);
                            tempwidth2-=tempBLK[0].length;
                            if(tempwidth2==0){
                                tempThikcness2-=tempBLK[0].thickness;
                                if(tempThikcness2==0){
                                    templength2-=tempBLK[0].width;
                                }
                            }

                            tempBLK.shift();
                        }
                    }



            }
       }*/
      };
      const DrawElements = () => {
        let [templength, tempwidth, tempThikcness, Elements, MaxInRow,thickIndex,coloumn] = [
          totalLength,
          totalWidth,
          totalThickness,
          JSON.parse(JSON.stringify(LP)),
          LP[0].length,
          0,
          0
        ];

        let deletedElement = null;
        let thicks = [];
        let temp=0;

        while (Elements.length > 0) {
          // Ensure thickness is within valid bounds
          if (templength <= 0) {
            console.error("tempThikcness has become non-positive, exiting loop.");
            break;
          }
          while (templength >= Elements[0]?.length) {
            tempThikcness = totalThickness;
            thickIndex = 0;
          while (tempThikcness >= Elements[0]?.thickness) {
            tempwidth = totalWidth;
            temp+=((Elements[0].length*Elements[0].thickness));

            if(
              templength<totalLength){
                while(thicks[thickIndex]!=Elements[0]?.thickness){

                  tempThikcness-=thicks[thickIndex++];

                }
              }
            while (tempwidth >= Elements[0]?.width
            ) {
            if(Elements[0]["partLot_BuildingType_c"]=="MP"){

              createLP(
                Elements[0].length,
                Elements[0].thickness,
                Elements[0].width,
                resizeFactor,
                (totalLength - templength) * resizeFactor,
                (totalWidth - tempwidth) * resizeFactor,
                (totalThickness - tempThikcness) * resizeFactor,
                scene
              );}

              else if(Elements[0]["partLot_BuildingType_c"]=="BLK"){
                createBLK(
                  Elements[0].length,
                  Elements[0].thickness,
                  Elements[0].width,
                  resizeFactor,
                  (totalLength - templength) * resizeFactor,
                  (totalWidth - tempwidth) * resizeFactor,
                  (totalThickness - tempThikcness) * resizeFactor,
                  scene
                );
              }



              if(templength==totalLength&&tempwidth==totalWidth){
                thicks.push(Elements[0]?.thickness);

              }
              if(tempwidth==totalWidth){
                MaxInRow=Math.max(MaxInRow,Elements[0].length);
              }
              deletedElement = Elements.shift();
              tempwidth -= deletedElement?.width;

              if (tempwidth <= 0) {
                break;
              }

              if (!deletedElement) {
                console.error("deletedElement is null, exiting loop.");
                return;
              }

              if (Elements.length == 0) {
                return;
              }
            }


          tempThikcness -= deletedElement.thickness;
           thickIndex++;
           if(tempwidth<Elements[0]?.width
            &&tempThikcness<Elements[0]?.thickness
            &&templength>=Elements[0]?.length
          ){
            templength-=MaxInRow;

            MaxInRow=0;

          }
            // Check to prevent negative thickness
            if (tempThikcness <= 0) {
              break;
            }

          }

        };

          // Extra safety check to ensure we don't get stuck in an infinite loop
          if (tempThikcness <= 0 || tempwidth <= 0) {
            console.error("Unexpected condition encountered, breaking the loop.");
            break;

          }
        }
        setUnCoveredArea(totalArea-(temp/Math.pow(10,6)));
      };



      if (profile != "MP") {
        DrawLPAndBLK();
      } else {
        DrawElements();
      }
      var animate = function () {
        requestAnimationFrame(animate);

        //orbit.update(); // Update the controls in the animation loop
        renderer.render(scene, camera);
      };
      const TopButton = document.getElementById("top-button");
      const raycaster = new THREE.Raycaster();
      const mouse = new THREE.Vector2();
      let intersects = [];
      if (mode === "top") {
        camera.position.z = 6;
        camera.position.y = 0;
        camera.position.x = 0;
        scene.position.x = -4;
        scene.position.y = -0.5;
        scene.position.z = 3;
        scene.rotation.x = 1.35;
        scene.rotation.y = 0.05;
        scene.rotation.z = -0.3;
        orbit.enabled = false;

        scene.updateMatrixWorld();
        raycaster.intersectObjects(scene.children);
        raycaster.setFromCamera(mouse, camera);
        const onClick = (event) => {
          // Calculate mouse position in normalized device coordinates (-1 to +1)
          mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
          mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

          // Update the raycaster with the camera and mouse position
          raycaster.setFromCamera(mouse, camera);

          // Calculate objects intersecting the picking ray
          intersects = raycaster.intersectObjects(scene.children);
          // console.log(intersects);
          // Check if the base was clicked
          if (intersects.length > 0 && intersects[0]?.object == base) {
            setIsOpen(true); // Handle click on the base
          }
        };

        // Attach event listener to the renderer's DOM element
        renderer.domElement.addEventListener("click", onClick);
      }
      animate();
      const color = 0xffffff;
      const intensity = 5;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(4, 4, 4);

      scene.add(light);
      const light2 = light.clone();
      light2.position.set(-4, -4, -4);
      scene.add(light2);
      const light3 = light.clone();
      light3.position.set(10, 8, 0);
      light3.intensity = 2;
      scene.add(light3);
      const light4 = light.clone();
      light4.position.set(-10, -8, 0);
      scene.add(light4);



    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    // Clean up on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      if (LBContainer.current&& renderer?.domElementt) {
        LBContainer.current.removeChild(renderer.domElement);
      }
    };
  }, [color, createLP, mode]);
  return (LP&&
    <>
      <div className="table-bg  p-4 mt-3 m-1 " style={{}}>
        <div className="d-flex justify-content-between  ">
          <h3>3D Visalizaion</h3>
          <div className="legend">
            <div>
              <div
                style={{
                  background: "#ff9900",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginLeft: "0.3em"
                }}
              ></div>
              <span>BLK</span>
            </div>

            <div>
              <div
                style={{
                  background: color,
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginLeft: "0.3em"
                }}
              ></div>
              <span>{profile}</span>
            </div>
            <div>
              <span
                style={{
                  fontSize: "1em",
                  display: "inline-block",
                  marginLeft: "0.45em"
                }}
              >
                <strong>Total Area:</strong>
              </span>
              <span>{` ` + totalArea}</span>
            </div>
            <div>
              <span
                style={{
                  fontSize: "1em",
                  display: "inline-block",
                  marginLeft: "0.45em"
                }}
              >
               
              </span>
            {/*}   <strong>Empty Space:</strong>
              <span>{` ` + UnCoveredArea.toFixed(3)}</span>*/}
            </div>
            {UnCoveredArea.toFixed(1)>0&&(
            <button className="submit-btn ro d-block m-2 rounded  "
            style={{
              padding: "0.5em",
              fontSize: "1em",
              color: "white",
              width: "fit-content"
            }}onClick={() => setIsOpen(true)}>
            fill Empty space
            </button>)
            }
          </div>

          <select
            className="form-select"
            style={{
              maxWidth: "200px",
              padding: "0.5em",
              marginBottom: "10px"
            }}
            defaultValue={"free"}
            onChange={(e) => setMode(e.target.value)}
          >
            <option value="free">Free Rotation </option>
            <option value="top">Top View</option>
          </select>
        </div>
        <div className="vis-container">
          <div ref={LBContainer}></div>
        </div>
      </div>
    </>
  );
};

export default LB3D;
